import React from "react";
import { Alert, AlertTitle } from "@mui/material";

export default function OrderNotFoundScreen() {
    return (
        <Alert severity="warning" variant="outlined">
            <AlertTitle>Shipment Not Found</AlertTitle>
            We couldn't find the shipment you're looking for. Please check your tracking number or order ID and try again.
        </Alert>
    );
}
